var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
import { Icon } from '../Icon/index.js';
const Dashed = props => {
    const { icon, children, className } = props, rest = __rest(props, ["icon", "children", "className"]);
    return (React.createElement("button", Object.assign({ type: "button", className: clsx('relative block w-full border-2 border-basicSurface-300/25 border-dashed rounded-lg p-12 text-center hover:border-basicSurface-400/50', 'focus:outline-none focus-visible:ring', className) }, rest),
        React.createElement(Icon, { className: "mx-auto h-12 w-12 text-basicSurface-400" }, icon),
        React.createElement("span", { className: "mt-2 block text-basicSurface-900" }, children)));
};
export const EmptyState = (props) => {
    const { title, description, icon, children } = props;
    return (React.createElement("div", { className: "text-center" },
        React.createElement(Icon, { className: "mx-auto h-12 w-12 text-basicSurface-400" }, icon),
        React.createElement("h3", { className: "mt-2 text-basicSurface-900" }, title),
        description && (React.createElement("p", { className: "mt-1 text-basicSurface-500" }, description)),
        children && React.createElement("div", { className: "mt-6" }, children)));
};
EmptyState.Dashed = Dashed;
//# sourceMappingURL=EmptyState.js.map